import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { CallingActions } from "./index";
import {
    FETCH_CALL_CAMPAIGN_LIST_PROGRESS,
    FETCH_CALL_CAMPAIGN_LIST_SUCCESS,
    FETCH_CALL_CAMPAIGN_LIST_FAILED,
    FETCH_CALL_CAMPAIGN_PROGRESS,
    FETCH_CALL_CAMPAIGN_SUCCESS,
    FETCH_CALL_CAMPAIGN_FAILED,
    FETCH_CALL_CAMPAIGN_DATA_LIST_PROGRESS,
    FETCH_CALL_CAMPAIGN_DATA_LIST_SUCCESS,
    FETCH_CALL_CAMPAIGN_DATA_LIST_FAILED,
    FETCH_CALL_CAMPAIGN_DATA_PROGRESS,
    FETCH_CALL_CAMPAIGN_DATA_SUCCESS,
    FETCH_CALL_CAMPAIGN_DATA_FAILED,
    INSERT_BULK_CALL_CAMPAIGN_PROGRESS,
    INSERT_BULK_CALL_CAMPAIGN_SUCCESS,
    INSERT_BULK_CALL_CAMPAIGN_FAILED,
    ASSIGN_TO_LEAD_PROGRESS,
    ASSIGN_TO_LEAD_SUCCESS,
    ASSIGN_TO_LEAD_FAILED,
    ASSIGN_TO_AGENT_PROGRESS,
    ASSIGN_TO_AGENT_SUCCESS,
    ASSIGN_TO_AGENT_FAILED,
    CLEAR_CALL_CAMPAIGN_STATE,
    CLEAR_CALL_CAMPAIGN,
    CLEAR_CALL_CAMPAIGN_DATA_STATE,
    CLEAR_CALL_CAMPAIGN_DATA,
    CLEAR_BULK_CAMPAIGN_STATE,
    //CLEAR_BULK_CAMPAIGN,
    CLEAR_ASSIGNMENT_STATUS,
} from "./calling.actions"
import { InitialCallingState } from "./calling.states";

export const callingReducer = (
    state: IStoreState["calling"] = InitialCallingState,
    action: CallingActions
) => {
    switch (action.type) {
        // ==================== CALL CAMPAIGN REDUCERS ====================
        case FETCH_CALL_CAMPAIGN_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.list.loading = LoadState.InProgress
                draftState.callCampaign.list.list = []
                draftState.callCampaign.list.totalRecords = 0
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.list.loading = LoadState.Loaded
                draftState.callCampaign.list.list = list
                draftState.callCampaign.list.totalRecords = totalRecords
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_LIST_FAILED: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.list.loading = LoadState.Failed
                draftState.callCampaign.list.list = []
                draftState.callCampaign.list.totalRecords = 0
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.data.loading = LoadState.InProgress
                draftState.callCampaign.data.data = null
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_SUCCESS: {
            const { callCampaign } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.data.loading = LoadState.Loaded
                draftState.callCampaign.data.data = callCampaign
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.data.loading = LoadState.Failed
                //draftState.callCampaign.data.data = null
                draftState.callCampaign.data.error = errorMessage
            })
            return newState;
        }
        case CLEAR_CALL_CAMPAIGN_STATE: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaign = InitialCallingState.callCampaign
            })
            return newState;
        }
        case CLEAR_CALL_CAMPAIGN: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaign.data.data = null
            })
            return newState;
        }
        // ==================== CALL CAMPAIGN DATA REDUCERS ====================
        case FETCH_CALL_CAMPAIGN_DATA_LIST_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.list.loading = LoadState.InProgress
                draftState.callCampaignData.list.list = []
                draftState.callCampaignData.list.totalRecords = 0
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_DATA_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.list.loading = LoadState.Loaded
                draftState.callCampaignData.list.list = list
                draftState.callCampaignData.list.totalRecords = totalRecords
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_DATA_LIST_FAILED: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.list.loading = LoadState.Failed
                draftState.callCampaignData.list.list = []
                draftState.callCampaignData.list.totalRecords = 0
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_DATA_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.data.loading = LoadState.InProgress
                draftState.callCampaignData.data.data = null
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_DATA_SUCCESS: {
            const { callCampaignData } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.data.loading = LoadState.Loaded
                draftState.callCampaignData.data.data = callCampaignData
            })
            return newState;
        }
        case FETCH_CALL_CAMPAIGN_DATA_FAILED: {
            const { errorMessage } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.data.loading = LoadState.Failed
                //draftState.callCampaignData.data.data = null
                draftState.callCampaignData.data.error = errorMessage
            })
            return newState;
        }
        case CLEAR_CALL_CAMPAIGN_DATA_STATE: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData = InitialCallingState.callCampaignData
            })
            return newState;
        }
        case CLEAR_CALL_CAMPAIGN_DATA: {
            const newState = produce(state, (draftState) => {
                draftState.callCampaignData.list.list = []
                draftState.callCampaignData.list.totalRecords = 0
            })
            return newState;
        }

        // ==================== BULK CALL CAMPAIGN REDUCERS ====================

        case INSERT_BULK_CALL_CAMPAIGN_PROGRESS: {
            const newState = produce(state, (draftState) => {
                draftState.bulkCampaign.data.loading = LoadState.InProgress
                draftState.bulkCampaign.data.data = null
            })
            return newState;
        }
        case INSERT_BULK_CALL_CAMPAIGN_SUCCESS: {
            const { data } = action.payload;
            const newState = produce(state, (draftState) => {
                draftState.bulkCampaign.data.loading = LoadState.Loaded
                draftState.bulkCampaign.data.data = data
            })
            return newState;
        }
        case INSERT_BULK_CALL_CAMPAIGN_FAILED: {
            const newState = produce(state, (draftState) => {
                draftState.bulkCampaign.data.loading = LoadState.Failed
                draftState.bulkCampaign.data.error = (action as any).payload?.errorMessage || "Unknown error"
            })
            return newState;
        }
        case CLEAR_BULK_CAMPAIGN_STATE: {
            const newState = produce(state, (draftState) => {
                draftState.bulkCampaign = InitialCallingState.bulkCampaign
            })
            return newState;
        }
        // case CLEAR_BULK_CAMPAIGN: {
        //     const newState = produce(state, (draftState) => {
        //         draftState.bulkCampaign.data.data = null
        //     })
        //     return newState;
        // }
        // ====================  CALL CAMPAIGN DATA ASSIGN TO LEAD REDUCERS ====================
      
        case ASSIGN_TO_LEAD_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.InProgress;
                draftState.assignmentStatus.error = null;
            });
        }
        case ASSIGN_TO_LEAD_SUCCESS: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.Loaded;
                draftState.assignmentStatus.error = null;
            });
        }
        case ASSIGN_TO_LEAD_FAILED: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.Failed;
                draftState.assignmentStatus.error = "Lead assignment failed";
            });
        }

        // ==================== ASSIGN TO AGENT REDUCERS ====================
        case ASSIGN_TO_AGENT_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.InProgress;
                draftState.assignmentStatus.error = null;
            });
        }
        case ASSIGN_TO_AGENT_SUCCESS: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.Loaded;
                draftState.assignmentStatus.error = null;
            });
        }
        case ASSIGN_TO_AGENT_FAILED: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus.loading = LoadState.Failed;
                draftState.assignmentStatus.error = "Agent assignment failed";
            });
        }

        // ==================== CLEAR STATUS ====================
        case CLEAR_ASSIGNMENT_STATUS: {
            return produce(state, (draftState) => {
                draftState.assignmentStatus = InitialCallingState.assignmentStatus;
            });
        }
        default:
            return state;
    }
}